import React, { useState } from "react";
import { useEffect } from "react";
import VideoComponent from "../videoComponent";
import QuestionComponent from "../questionComponent";
import MypaLinkComponent from "../mypaLinkComponent";
import TextComponent from "../textComponent";
import DocumentComponent from "../documentComponent";
import VoucherComponent from "../voucherComponent";
import DocumentsComponent from "../documentsComponent";
import { Button } from "../../common";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import WarningIcon from "@mui/icons-material/Warning";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { isEmpty } from "lodash";

import "./style.scss";
import RatingComponent from "../ratingComponent";

const CourseComponent = (props) => {
  let history = useNavigate();
  const {
    markAsComplete,
    markLessonLocation,
    markUnitStartedOrCompleted,
    markInteraction,
    markFinish,
    scormData,
    apiGatewayWelcome,
    markVideoProgress,
    markRating,
    origin,
  } = props;
  const [unit, setUnit] = useState({ unit: {}, id: 0 });
  const [started, setStarted] = useState(false);
  const [unlocked, setUnlocked] = useState(false);
  const [voucher, setVoucher] = useState({
    id: 19749,
    link: "https://beta.alwaysfoodsafe.com/learn/launch/3UBH-CK2B",
    externalInviteId: "OR5N5VWXN8RW",
  });
  const [units, setUnits] = useState([]);
  const [currentUnit, setCurrentUnit] = useState(0);
  const [showUnits, setShowUnits] = useState(true);
  const { t } = useTranslation();

  // console.log("-------------------CourseComponent------------------");
  // console.log(props);

  useEffect(() => {
    if (voucher?.claimed_on) {
      onUnlock();
    }
  }, [voucher]);

  function setUnitState(unit) {
    setUnit(unit);
  }

  // isAutoplaySupported(callback);
  // Test if HTML5 video autoplay is supported
  const isAutoplaySupported = (callback) => {
    try {
      // Is the callback a function?
      if (typeof callback !== "function") {
        console.log("isAutoplaySupported: Callback must be a function!");
        return false;
      }
      // Check if sessionStorage exist for autoplaySupported,
      // if so we don't need to check for support again
      if (!sessionStorage.autoplaySupported) {
        // Create video element to test autoplay
        var video = document.createElement("video");
        video.autoplay = true;
        video.src =
          "data:video/mp4;base64,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";
        video.load();
        video.style.display = "none";
        video.playing = false;
        video.play().catch((reason) => {
          sessionStorage.autoplaySupported = "false";
          callback(false);
        });
        // Check if video plays
        video.onplay = function () {
          this.playing = true;
        };
        // Video has loaded, check autoplay support
        video.oncanplay = function () {
          if (video.playing) {
            sessionStorage.autoplaySupported = "true";
            callback(true);
          } else {
            sessionStorage.autoplaySupported = "false";
            callback(false);
          }
        };
      } else {
        // We've already tested for support
        // use sessionStorage.autoplaySupported
        if (sessionStorage.autoplaySupported === "true") {
          callback(true);
        } else {
          callback(false);
        }
      }
    } catch {
      return false;
    }
  };

  useEffect(() => {
    if (props.data.units.length > 0) {
      setUnlocked((props.data.require_voucher ?? false) === false);
      props.data.units = props.data.units.filter((unit, idx) => {
        unit.position = idx;
        unit.id = idx;
        return !unit.complete && !unit.disabled;
      });

      isAutoplaySupported(function (supported) {
        console.log("Autoplay:", supported);
        setStarted(supported);
      });

      setUnits(props.data.units);
      setUnitState({
        unit: props.data.units[0],
        id: props.data.units[0].position,
      });
    }
  }, []);

  useEffect(() => {
    if (scormData.id) {
      for (let i = 0; i < parseInt(scormData.lesson_location); i++) {
        if (i < props.data.units.length) {
          props.data.units[i].completed = true;
        }
        if (i + 1 < props.data.units.length) {
          props.data.units[i + 1].disabled = false;
        }
      }
      setUnits(props.data.units);
      const lastLocation = parseInt(scormData.lesson_location);
      if (lastLocation) {
        const tmpUnit = props.data.units[lastLocation];
        if (tmpUnit) {
          setCurrentUnit(lastLocation);
          setUnit({ unit: tmpUnit, id: lastLocation });
        }
      }
    }
  }, [scormData]);

  useEffect(() => {
    if (
      !unit.unit.completed &&
      unit.unit.on_start &&
      unit.unit.on_start.length > 0
    ) {
      unit.unit.on_start.forEach(function (value) {
        // console.log(`starting: ${value}`);
        markUnitStartedOrCompleted("start", value);
      });
    }
  }, [unit]);

  const jumpToNextUnit = (event) => {
    setCurrentUnit(currentUnit + 1);
    setUnit({ unit: props.data.units[event + 1], id: event + 1 });
  };

  const updateCurrentUnit = (event) => {
    let _units = Object.assign([], units);
    if (!_units[currentUnit].completed) {
      if (
        _units[currentUnit].on_complete &&
        _units[currentUnit].on_complete.length > 0
      ) {
        _units[currentUnit].on_complete.forEach(function (value) {
          // console.log(`completed: ${value}`);
          markUnitStartedOrCompleted("complete", value);
        });
      }
    }
    _units[currentUnit].completed = true;
    markLessonLocation(currentUnit + 1);
    jumpToNextUnit(event);
    setUnits(_units);
  };

  const onUnlock = () => {
    setUnlocked(true);
  };

  const markAsCompleteAndClose = () => {
    // let _units = Object.assign([], units);
    // _units[currentUnit].completed = true;
    // setUnits(_units);
    markLessonLocation(currentUnit + 1);
    markAsComplete();
    markFinish();
    history("/course-finished");
  };

  const goToUnit = (_unit, idx) => {
    if (_unit.completed) {
      setCurrentUnit(idx);
      setUnitState({ unit: _unit, id: idx });
    }
  };

  const applyApiGatewayWelcome = (event, sub) => {
    let _units = Object.assign([], units);
    _units[currentUnit].completed = true;
    if (sub) {
      apiGatewayWelcome(sub);
    }
    markLessonLocation(currentUnit + 1);
    jumpToNextUnit(event);
    setUnits(_units);
  };

  const HeaderTitle = ({ title, subtitle }) => {
    const changeLanguage = (e) => {
      i18n.changeLanguage(e.target.value);
    };

    return (
      <div className="header">
        <div className="title">{title}</div>
        <div className="subtitle">
          {props.data.languages && props.data.languages.length > 1 && (
            <select onChange={changeLanguage} value={i18n.language}>
              {props.data.languages.map((l) => (
                <option key={`option${l}`} value={l}>
                  {l}
                </option>
              ))}
            </select>
          )}
        </div>
      </div>
    );
  };

  const getTitle = (_unit) => {
    if (_unit.type === "finish") {
      return t("Finish");
    } else if (_unit.type === "document_summary") {
      return t("Document Summary");
    } else {
      if (!(_unit.title)) {
        return "";
      }
      if (_unit.approx_length && _unit.approx_length.length > 0) {
        return `${_unit.title[i18n.language]} (${_unit.approx_length})`;
      }
      return _unit.title[i18n.language];
    }
  };

  return (
    <div className="root">
      <div className="textComponent">
        <HeaderTitle
          key={`title${unit.id}`}
          title={props.data.title[i18n.language]}
          subtitle={""}
        />
      </div>

      {unlocked === false && (
        <div className="textComponent">
          <div className="contentComponent">
            <VoucherComponent
              packageId={props.packageId}
              studentId={scormData.id}
              setVoucher={setVoucher}
            />
          </div>
        </div>
      )}

      {unlocked && started === false && (
        <div className="completeContainer">
          <div className="btnContainer">
            <Button
              variant="primary"
              className="button"
              onClick={() => setStarted(true)}
            >
              {t("Begin Course")}
            </Button>
          </div>
        </div>
      )}

      {unlocked && started === true && (
        <>
          {unit.unit.type === "mypa-link" && (
            <div className="textComponent">
              <div className="contentComponent">
                <MypaLinkComponent
                  applyApiGatewayWelcome={applyApiGatewayWelcome}
                  jumpToNextUnit={jumpToNextUnit}
                  data={unit}
                  updateCurrentUnit={updateCurrentUnit}
                  scormDataId={scormData.id}
                  key={`mypalink${unit.id}`}
                  auth={props.auth}
                  origin={origin}
                />
              </div>
            </div>
          )}

          {unit.unit.type === "video" && (
            <div className="videoComponent">
              <div className="contentComponent">
                <VideoComponent
                  markVideoProgress={markVideoProgress}
                  updateCurrentUnit={updateCurrentUnit}
                  jumpToNextUnit={jumpToNextUnit}
                  data={unit}
                  video_link_id={props.data.video_link_id}
                  key={`video${unit.id}`}
                  schemaVersion={props.data.schema_version ?? 2}
                  videoAlias={props.data.number}
                  studentId={scormData.id}
                />
              </div>
            </div>
          )}
          {unit.unit.type === "text" && (
            <div className="textComponent">
              <div className="contentComponent">
                <TextComponent
                  updateCurrentUnit={updateCurrentUnit}
                  jumpToNextUnit={jumpToNextUnit}
                  data={unit}
                  key={`text${unit.id}`}
                />
              </div>
            </div>
          )}
          {unit.unit.type === "question" && (
            <div className="questionComponent">
              <div className="contentComponent">
                <QuestionComponent
                  updateCurrentUnit={updateCurrentUnit}
                  jumpToNextUnit={jumpToNextUnit}
                  markInteraction={markInteraction}
                  video_link_id={props.data.video_link_id}
                  data={unit}
                  key={`question${unit.id}`}
                  schemaVersion={props.data.schema_version ?? 2}
                  videoAlias={props.data.number}
                  studentId={scormData.id}
                />
              </div>
            </div>
          )}
          {unit.unit.type === "document" && (
            <div className="textComponent">
              <div className="contentComponent">
                <DocumentComponent
                  updateCurrentUnit={updateCurrentUnit}
                  jumpToNextUnit={jumpToNextUnit}
                  data={unit}
                  key={`document${unit.id}`}
                />
              </div>
            </div>
          )}
          {unit.unit.type === "document_summary" && (
            <div className="textComponent">
              <div className="contentComponent">
                <DocumentsComponent
                  updateCurrentUnit={updateCurrentUnit}
                  jumpToNextUnit={jumpToNextUnit}
                  data={unit}
                  key={`documents${unit.id}`}
                />
              </div>
            </div>
          )}
          {unit.unit.type === "rating" && !unit.unit.completed && (
            <div className="textComponent">
              <div className="contentComponent">
                <RatingComponent
                  updateCurrentUnit={updateCurrentUnit}
                  jumpToNextUnit={jumpToNextUnit}
                  markRating={markRating}
                  data={unit}
                  key={`text${unit.id}`}
                />
              </div>
            </div>
          )}
          {unit.unit.type === "finish" && (
            <div className="completeContainer">
              <Stack
                className="result"
                spacing={2}
                direction="column"
                alignContent="center"
                sx={{
                  textAlign: "center",
                  color: "white",
                }}
              >
                <div>
                  <CheckCircleIcon htmlColor="#8eb53e" sx={{ fontSize: 60 }} />
                </div>
                <div style={{ fontSize: "1.5em" }}>{t("Finish")}</div>
                {!isEmpty(voucher) && voucher.validator === "afs" ? (
                  <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    spacing={2}
                    sx={{
                      textAlign: "center",
                      color: "white",
                      paddingBottom: 10,
                    }}
                  >
                    <Grid item xs={12}>
                      <div style={{ fontSize: "1.5em" }}>
                        {t(
                          "Congratulations on completing your training! It is now time to take your final exam."
                        )}
                      </div>
                    </Grid>
                    <Grid container item xs={6} justifyContent={"flex-end"}>
                      <Grid item>
                        <Button
                          onClick={() => {
                            window.open(voucher.metadata.instructions_url);
                          }}
                        >
                          {" "}
                          <span style={{ paddingRight: 5 }}>Instructions</span>
                          <i class="fas fa-external-link-alt"></i>
                        </Button>
                      </Grid>
                    </Grid>
                    <Grid item xs={6}>
                      <Button
                        onClick={() => {
                          markAsCompleteAndClose();
                          window.open(voucher.metadata.link);
                        }}
                      >
                        <span style={{ paddingRight: 5 }}>Go to Exam </span>
                        <i class="fas fa-external-link-alt"></i>
                      </Button>
                    </Grid>
                  </Grid>
                ) : (
                  <>
                    <div>{t("Good job, that is correct!")}</div>
                    <div className="btnContainer">
                      <Button
                        className="button"
                        variant="primary"
                        onClick={markAsCompleteAndClose}
                      >
                        {t("Check as completed")}
                      </Button>
                    </div>
                  </>
                )}
              </Stack>
            </div>
          )}
          {unit.unit.type === "prequiz-start" && (
            <div className="completeContainer">
              <Stack
                className="result"
                spacing={2}
                direction="column"
                alignContent="center"
                sx={{
                  textAlign: "center",
                  color: "white",
                }}
              >
                <div>
                  <CheckCircleIcon htmlColor="#8eb53e" sx={{ fontSize: 60 }} />
                </div>
                <div style={{ fontSize: "1.5em" }}>{t("Knowledge Check")}</div>
                <div>This course comes with a Pre-Test consisting of {unit.unit.count} questions.  After the Pre-Test, the course will resume as it would normally.</div>
                <div className="btnContainer">
                  <Button
                    className="button"
                    variant="primary"
                    onClick={() => updateCurrentUnit(unit.id)}
                  >
                    {t("Start the Pre-Test")}
                  </Button>
                </div>
              </Stack>
            </div>
          )}
          {unit.unit.type === "prequiz-finish" && (
            <div className="completeContainer">
              <Stack
                className="result"
                spacing={2}
                direction="column"
                alignContent="center"
                sx={{
                  textAlign: "center",
                  color: "white",
                }}
              >
                <div>
                  <CheckCircleIcon htmlColor="#8eb53e" sx={{ fontSize: 60 }} />
                </div>
                <div style={{ fontSize: "1.5em" }}>{t("Knowledge Check Complete")}</div>
                <div>{t("Good job!")}</div>
                <div className="btnContainer">
                  <Button
                    className="button"
                    variant="primary"
                    onClick={() => updateCurrentUnit(unit.id)}
                  >
                    {t("Continue to Course")}
                  </Button>
                </div>
              </Stack>
            </div>
          )}
          <div className="unitsComponent">
            <div className="unitsConent">
              <div
                className="header"
                onClick={() => {
                  setShowUnits(!!!showUnits);
                }}
              >
                <div className="text">{t("Course Outline")}</div>
                <div
                  className={showUnits ? "triangle-down" : "triangle-up"}
                ></div>
              </div>
              {showUnits &&
                units.map((_unit, idx) => {
                  if (!_unit.disabled)
                    return (
                      <div
                        key={idx}
                        className={`unit ${_unit.completed ? "clickable" : ""}`}
                        style={{
                          display: _unit.hide_from_outline ? "none" : "",
                        }}
                        onClick={() => goToUnit(_unit, idx)}
                      >
                        {_unit.completed && (
                          <div className="dot active">
                            {_unit.completed && (
                              <div className="check">&#10004;</div>
                            )}
                          </div>
                        )}
                        {!_unit.completed && unit.unit.id == _unit.id && (
                          <div className="dot selected"></div>
                        )}
                        {!_unit.completed && unit.unit.id != _unit.id && (
                          <div className="dot"></div>
                        )}
                        <div className="text">{getTitle(_unit)}</div>
                      </div>
                    );
                })}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CourseComponent;
